import { ChangeDetectionStrategy, Component, ViewEncapsulation, forwardRef, input, output } from "@angular/core";
import { Wrapper } from "../wrapper.interface";
import { ChipModule } from "primeng/chip";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { Color } from "../util";
import { WRAPPER_TOKEN } from "../wrapper.tokens";
import { ChipConfig } from "./chip.config";

@Component({
    selector:        'v-chip',
    templateUrl:     './chip.component.haml',
    styleUrls:       ['./chip.component.sass'],
    encapsulation:   ViewEncapsulation.None,
    providers:       [{ provide: WRAPPER_TOKEN, useExisting: forwardRef(() => VChipComponent) }],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports:         [CommonModule, ChipModule, ReactiveFormsModule]
})
export class VChipComponent extends Wrapper<ChipConfig>{
    protected _baseConfig: ChipConfig = ChipConfig.baseTheme.Default;
    public onRemove = output<MouseEvent>();
    public removable = input<boolean>();
    public image = input<string>();
    public alt = input<string>();

    public getColorStyle(color: Color) {
        return `severity-${color}`;
    }
}